export default "__VITE_ASSET__DLiK7gZ3__"